module.exports = __webpack_public_path__ + "img/chevron-left.bdde5e6d.svg";